
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/accessibility",
      function () {
        return require("private-next-pages/nl/accessibility.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/accessibility"])
      });
    }
  